import HexController from "controllers/hex_controller"

export default class extends HexController {
  static targets = ['conventionTooltip', 'parameterizedField']

  connect() {
    if(this.hasConventionTooltipTarget) {
      Tipped.create(`#${this.conventionTooltipTarget.id}`, this.conventionTooltipTarget.dataset.tippedBody, {
        skin: 'light',
        maxWidth: 400,
        position: { target: 'bottomleft' }
      });
    }
  }

  insertAtCaret(obj, text) {
    let start;
    if(document.selection) {
      obj.focus();
      const orig = obj.val().replace(/\r\n/g, "\n");
      const range = document.selection.createRange();

      if(range.parentElement() !== obj[0]) {
        return false;
      }

      range.text = text;

      let tmp = obj.val().replace(/\r\n/g, "\n");
      const actual = tmp;

      for(var diff = 0; diff < orig.length; diff++) {
        if(orig.charAt(diff) !== actual.charAt(diff)) break;
      }

      start = 0;
      for(var index = 0;  tmp.match(text) && (tmp = tmp.replace(text, "")) && index <= diff; index = start + text.length) {
        start = actual.indexOf(text, index);
      }
    } else if(obj[0].selectionStart) {
      start = obj[0].selectionStart;
      const end   = obj[0].selectionEnd;
      obj.val(obj.val().substr(0, start) + text + obj.val().substr(end, obj.val().length));
    }

    if(start != null) {
      this.setCaretTo(obj, start + text.length);
    } else {
      obj.val(obj.val() + text);
    }
  }

  setCaretTo(obj, pos) {
    if(obj.createTextRange) {
      var range = obj.createTextRange();
      range.move("character", pos);
      range.select();
    } else if(obj[0].selectionStart) {
      obj.focus();
      obj[0].setSelectionRange(pos, pos);
    }
  }

  insertFieldValue(event) {
    if(event.type === "click" || (event.type === "keydown" && event.ctrlKey && event.keyCode === 89)) {
      const targetData = event.target.dataset;

      // Grab the current scroll position
      const auto_position = $(targetData.textArea).scrollTop;
      const test_script = $(targetData.textArea);
      this.insertAtCaret(test_script, '{' + $(targetData.scriptParameters).val() + '}');

      var control = $(targetData.scriptParameters)[0];

      if(control.selectedIndex !== control.options.length - 1) {
        control.selectedIndex = control.selectedIndex + 1;
      }

      // Restore the old scroll position
      $(targetData.textArea).scrollTop = auto_position;
    }
  }

  changeFieldType(event) {
    if(this.hasParameterizedFieldTarget) {
      if(event.target.value === "text") {
        this.parameterizedFieldTarget.classList.remove('hidden');
      } else {
        this.parameterizedFieldTarget.classList.add('hidden');
      }
    }
  }
}